import { remoteCustomFetcher } from '@/providers/backendClient';
import { CustomPipelineFactory } from '@/providers/dataProvider';

export const appTrackerCustomFetcher: CustomPipelineFactory = async ({
  sort,
  filter,
  page,
  perPage,
}) => {
  const result = await remoteCustomFetcher('appTrackerEvents', {
    sort,
    filter,
    page,
    perPage,
  });

  return result;
};
